import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Utils from '../common/utils.js';
import FormCheckbox from './form_checkbox.js';
import { DatePickerWrapper } from '../../helpers/wrappers.js';
import { isValidInputDate } from '../../../widgets/utilities/helperUtility';

class DatePicker extends Component {
  constructor(props) {
    super(props);
    let selected = props.selected;
    if (props.selected && !props.selected.format()) {
      selected = dayjs().tz(props.timeZone);
    }

    this.state = {
      selected,
    };
  }

  onChangeRaw = (e) => {
    const m = dayjs(e.target.value);
    if (m.isValid() && isValidInputDate(e.target.value)) {
      this.handleChangeStart(m);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ selected: nextProps.selected });
  }

  handleChangeStart(date) {
    this.setState({ selected: date });
    this.props.onChange(dayjs(date));
  }

  dateTimeFormat() {
    const { dFormat } = this.props;
    if (this.props.showTimeSelect) {
      return Utils.dateTimeFormat(dFormat);
    }
    return Utils.dateFormat(dFormat);
  }


  componentDidMount() {
    if (!this.props.dpForFromField) return;
    this.props.setDpRef(this.refs.datepicker);
  }

  showTime() {
    const { timeInterval: tInterval } = this.props;
    let showTime = {};
    if (this.props.showTimeSelect) {
      const timeFormat = Utils.timeFormat();

      showTime = {
        timeFormat,
        timeIntervals: Utils.timeInterval(tInterval),
        timeCaption: 'Time',
      };
    }
    showTime.dateFormat = this.dateTimeFormat();
    return showTime;
  }

  convertSelectedToDate() {
    const { selected } = this.state;

    if (selected && selected.format() !== 'Invalid date') {
      return dayjs(selected.format('YYYY-MM-DD HH:mm')).toDate();
    }

    return undefined;
  }

  datepickerTemplate() {
    const showTime = this.showTime();
    const { onChange, disabled, placeholderText, ...settings } = this.props;
    const selected = this.convertSelectedToDate();
    const placeholder = placeholderText || '';
    return (
      <DatePickerWrapper>
        <Datepicker
          {...showTime}
          {...settings}
          ref="datepicker"
          placeholderText={placeholder}
          onChangeRaw={this.onChangeRaw}
          onCalendarOpen={this.props.onOpen}
          onCalendarClose={this.props.onClose}
          selected={selected}
          onChange={(d) => this.handleChangeStart(d)}
          disabled={disabled}
          injectTimes={selected ? [selected] : []}
        >
          {this.props.showOverrideCheckBox && (
            <div className="override-container">
              <div className="checkbox m-r-xs m-t-none m-b-none">
                <FormCheckbox
                  id="override-times"
                  value={this.props.allowOverrideTimes}
                  onChange={this.props.setAllowOverrideTimes}
                />
                <label htmlFor="override-times">Allow all dates/times</label>
              </div>
            </div>
          )}
        </Datepicker>
      </DatePickerWrapper>
    );
  }

  onClick() {
    this.refs.datepicker.onInputClick();
  }

  render() {
    if (this.props.showIcon) {
      return (
        <div className="flexbox flexbox-datepicker">
          <div className="dp-wrapper">
            {this.datepickerTemplate()}
          </div>
          <span
            className="input-group-addon"
            onClick={() => this.onClick()}
            style={{ cursor: 'pointer', width: 'auto', padding: '9px 12px', height: 'fit-content' }}
          >
            <i className="fa fa-calendar" />
          </span>
        </div>
      );
    }
    return this.datepickerTemplate();
  }
}

DatePicker.propTypes = {
  showIcon: PropTypes.bool,
  selected: PropTypes.object,
  showTimeSelect: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

DatePicker.defaultProps = {
  showIcon: true,
  showTimeSelect: false,
  className: 'form-control',
};

export default DatePicker;
